<script>
  import { Wave } from "svelte-loading-spinners";
  import { scale } from "svelte/transition";
  import { createEventDispatcher, onMount } from "svelte";
  import config from "../../stores/config";
  import axios from "axios";

  export let show = false;
  export let title = "";

  let stockTReport = null;
  let queryURL;

  const fetchReport = () => {
    stockTReport = null;
    queryURL = `${$config.backendURL}/stocktake`;

    axios
      .get(queryURL)
      .then((res) => {
        stockTReport = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const dispatch = createEventDispatcher();

  const onClose = () => {
    dispatch("modalClose");
  };

  onMount(() => {
    fetchReport();
  });
</script>

{#if show}
  <div
    on:click|self={onClose}
    class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black/50"
    style="z-index: 999;"
  >
    <div
      transition:scale
      class="bg-gray-50 rounded-lg shadow-2xl py-4 px-5 border-t-2 border-brand overflow-auto"
      style="height: 90vh !important; max-height: 90vh !important;"
    >
      <!-- Window title -->
      <div class="flex justify-between mb-4">
        <div class="flex items-center">
          <i class="fas fa-chart-line mr-2 text-xl" />
          <div class="uppercase text-base flex items-center">
            Stock Take Report
          </div>
        </div>
        <div class="flex items-center justify-center">
          <button class="btn btn-primary" on:click={onClose}>
            <i class="fas fa-times-circle" />
          </button>
        </div>
      </div>

      <!-- Content -->
      <div
        class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
      >
        <div class="tr border-b border-gray-100 font-bold">
          <div style="min-width: 15rem; max-width: 15rem;">Item Name</div>
          <div style="min-width: 10rem; max-width: 10rem;">Date</div>
          <div style="min-width: 10rem; max-width: 10rem;">
            Counted from Stock
          </div>
          <div style="min-width: 10rem; max-width: 10rem;">
            Found in Database
          </div>
        </div>

        {#if stockTReport}
          {#each stockTReport as rep (rep._id)}
            <div class="tr border-b border-gray-100">
              <div style="min-width: 15rem; max-width: 15rem;">{rep.itemN}</div>
              <div style="min-width: 10rem; max-width: 10rem;">
                {new Date(rep.date).toDateString()}
              </div>
              <div style="min-width: 10rem; max-width: 10rem;">{rep.qtyP}</div>
              <div style="min-width: 10rem; max-width: 10rem;">{rep.qtyL}</div>
            </div>
          {:else}
            <div class="h-52 w-full flex items-center justify-center">
              Nothing to show...
            </div>
          {/each}
        {:else}
          <div class="h-52 w-full flex items-center justify-center">
            <Wave size="50" color="rgb(244,162,97)" unit="px" />
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 7.5px 20px;
  }
</style>
